import { render, staticRenderFns } from "./OrderCannot.vue?vue&type=template&id=0c27c764&scoped=true"
import script from "./OrderCannot.vue?vue&type=script&lang=js"
export * from "./OrderCannot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c27c764",
  null
  
)

export default component.exports